/** CPRE Rutland & Lincolnshire — Charity Commission registration */
export const CHARITY_NUMBER = '500480';

export const REGISTERED_CHARITY_LABEL = `Registered Charity No. ${CHARITY_NUMBER}`;
